import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { mergeRegister } from "@lexical/utils";
import { COMMAND_PRIORITY_EDITOR } from "lexical";
import { type FC, useEffect } from "react";
import { useToken } from "../../../../server/auth/use-token";
import type { ChannelName } from "../../../channels/types";
import { useClaims } from "../../../generic/hooks/use-claims";
import { $createVideoNode } from "../nodes/video-node-mui";
import { INSERT_VIDEO_COMMAND } from "../types/commands";
import { $insertNode } from "../utils/insert-node";

type VideoPluginProps = {
  channel: NonNullable<ChannelName>;
};

export const VideoPlugin: FC<
  VideoPluginProps & {
    anchorElem?: HTMLElement;
  }
> = ({ channel }): null => {
  const [editor] = useLexicalComposerContext();
  const user = useClaims();
  const getToken = useToken();

  useEffect(
    () =>
      mergeRegister(
        editor.registerCommand(
          INSERT_VIDEO_COMMAND,
          ({ videoUrl, thumbnailUrl, aspect, sourceAssetId, proportionOfMaxWidth, title }) => {
            $insertNode(
              $createVideoNode(
                editor._headless,
                videoUrl,
                thumbnailUrl,
                aspect,
                proportionOfMaxWidth,
                sourceAssetId,
                title,
              ),
            );
            return true;
          },
          COMMAND_PRIORITY_EDITOR,
        ),
      ),
    [editor, getToken, user, channel],
  );

  return null;
};
